import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Mail, Phone, MapPin } from "lucide-react";
import { api } from "../lib/api";
import NewsletterForm from "./NewsletterForm";

export default function Footer() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/settings").then(r => setS(r.data)).catch(() => {}); }, []);
  return (
    <footer className="bg-[#1A1728] text-white mt-24" data-testid="footer">
      <div className="lumina-container py-16">
        <div className="grid lg:grid-cols-3 gap-10 mb-12 pb-12 border-b border-white/10">
          <div className="lg:col-span-2">
            <h3 className="font-serif text-3xl mb-3">Tetap terhubung dengan kami.</h3>
            <p className="text-white/70 mb-5 max-w-md">Tips kesehatan mental, promo eksklusif, dan event terbaru langsung ke inbox-mu.</p>
            <NewsletterForm source="footer" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#9D84D2] to-[#E8F0FA] flex items-center justify-center">
              <span className="font-serif text-xl text-[#6B4BA3]">H</span>
            </div>
            <span className="font-serif text-2xl">HearInsight</span>
          </div>
          <p className="text-white/70 max-w-md leading-relaxed">
            {s.tagline || "Cahaya untuk Pikiran yang Tenang. Ruang aman untuk perjalanan kesehatan mentalmu."}
          </p>
          <div className="flex gap-3 mt-6">
            {s.social_instagram && <a href={s.social_instagram} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#6B4BA3] flex items-center justify-center transition-colors"><Instagram className="w-4 h-4" /></a>}
            {s.social_facebook && <a href={s.social_facebook} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#6B4BA3] flex items-center justify-center transition-colors"><Facebook className="w-4 h-4" /></a>}
            {s.social_linkedin && <a href={s.social_linkedin} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#6B4BA3] flex items-center justify-center transition-colors"><Linkedin className="w-4 h-4" /></a>}
          </div>
        </div>
        <div>
          <h4 className="lumina-label !text-white/60 mb-4">Navigasi</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/products" className="text-white/80 hover:text-white">Produk Digital</Link></li>
            <li><Link to="/services" className="text-white/80 hover:text-white">Layanan</Link></li>
            <li><Link to="/events" className="text-white/80 hover:text-white">Event</Link></li>
            <li><Link to="/about" className="text-white/80 hover:text-white">Tentang Kami</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="lumina-label !text-white/60 mb-4">Kontak</h4>
          <ul className="space-y-3 text-sm text-white/80">
            {s.contact_email && <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> {s.contact_email}</li>}
            {s.contact_phone && <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> {s.contact_phone}</li>}
            {s.address && <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-1 shrink-0" /> {s.address}</li>}
          </ul>
        </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="lumina-container py-6 text-white/50 text-sm">
          © {new Date().getFullYear()} HearInsight. Semua hak cipta dilindungi.
        </div>
      </div>
    </footer>
  );
}
